export default __webpack_public_path__ + "static/media/hetimiul_3.e2f828de.png";